<template>
<div>
    <law-court-form :getLawCourtList="getLawCourtList" ref="lawCourtFormModal"></law-court-form>
    <b-row>
        <b-col>
            <div style="float:left;" class="custom-search d-flex justify-content-end">
                <div class="align-items-center">
                        <label for="law-court-name-input">{{ $t('lawCourt.name') }}</label>
                        <b-form-group>
                        <b-form-input size="sm" v-model="searchTerm" :placeholder="$t('others.search')" type="text" class="d-inline-block" />
                    </b-form-group>
                </div>

                <div class="align-items-center ml-3">
                    <label for="law-court-type-input">{{ $t('lawCourt.lawCourtType') }}</label>
                    
                    <b-form-select id="law-court-type-input" v-model="lawCourtTypeSelect" size="sm" value-field="id" text-field="name" :options="lawCourtTypeOption" class="mb-2" />
                </div>
                <div class="align-items-center ml-3">
                    <label for="law-court-law-matter-case-type-input">{{ $t('lawCourt.law_matter_case_type') }}</label>
                    <b-form-select id="law-court-law-matter-case-type-input" v-model="lawMatterCaseTypeSelect" size="sm" value-field="id" text-field="name" :options="lawMatterCaseTypeOption" class="mb-2" />
                </div>
            </div>

            <div style="float:right;" class="custom-search d-flex justify-content-end">    
                <b-form-group>
                    <br />        
                    <div class="d-flex align-items-center">
                        <b-button class="mr-1" size="sm" variant="outline-primary" v-on:keyup.enter="getLawCourtList()" @click="getLawCourtList()">{{ $t('lawCourt.list') }}</b-button>
                        <b-button style="float:right; border-color:#6B7280; color:#374151;" class="mr-1" size="sm" variant="outline-secondary" @click="getInfo(0)">{{ $t('lawCourt.add') }}</b-button>
                        <b-button style="float:right; border-color:#6B7280; color:#374151;" size="sm" variant="outline-secondary" @click="exportExcel()">{{ $t('lawyerDailyworkReport.excel') }}</b-button>
                    </div>
                </b-form-group>
            </div>
        </b-col>
    </b-row>
    <!-- table -->
    <vue-good-table id="lawCourtTable" ref="lawCourtTable" :columns="columns" :rows="rows" styleClass="vgt-table condensed tableSize" :search-options="{
        enabled: true,
        externalQuery: searchTerm
      }" :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }" :pagination-options="{
        enabled: true,
        perPage: pageLength
      }" theme="my-theme">
        <div slot="emptystate">
            {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
            <span v-if="props.column.field === 'name'" class="text-nowrap">
                {{ $t('lawCourt.name') }}
            </span>
            <span v-else-if="props.column.field === 'lawCourtType'" class="text-nowrap">
                {{ $t('lawCourt.lawCourtType') }}
            </span>
            <span v-else-if="props.column.field === 'lawMatterCaseType'" class="text-nowrap">
                {{ $t('lawCourt.law_matter_case_type') }}
            </span>
            <span v-else-if="props.column.field === 'process'" class="text-nowrap">
            </span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field === 'process'">
                <list-actions-dropdown :actions="[
                    { icon: 'EditIcon', label: $t('others.edit'), handler: () => getInfo(props.row.id) },
                    { icon: 'XIcon', label: $t('others.delete'), color: '#DC2626', handler: () => deleted(props.row) }
                ]" />
            </span>
        </template>

        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
            <div class="d-flex justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-0 mt-1">
                    <span class="text-nowrap"> {{ $t('dataTable.total') }} {{ props.total }} {{ $t('dataTable.record') }}
                    </span>
                    <b-form-select v-model="pageLength" :options="['10', '25', '50', '100']" class="mx-1" @input="(value) => props.perPageChanged({ currentPerPage: value })" />
                    <span class="text-nowrap"> {{ $t('dataTable.row_is_show') }} </span>
                </div>
                <div>
                    <b-pagination :value="1" :total-rows="props.total" :per-page="pageLength" first-number last-number align="right" prev-class="prev-item" next-class="next-item" class="mt-1 mb-0" @input="(value) => props.pageChanged({ currentPage: value })">
                        <template #prev-text>
                            <feather-icon icon="ChevronLeftIcon" size="18" />
                        </template>
                        <template #next-text>
                            <feather-icon icon="ChevronRightIcon" size="18" />
                        </template>
                    </b-pagination>
                </div>
            </div>
        </template>
    </vue-good-table>
</div>
</template>

<script>
export default {
    data() {
        return {
            pageLength: 50,
            dir: false,
            lawMatterCaseTypeOption: [],
            lawMatterCaseTypeSelect: 0,
            lawCourtTypeOption: [],
            lawCourtTypeSelect: 0,
            columns: [{
                    label: this.$t('lawCourt.name'),
                    field: `name`,
                },
                {
                    label: this.$t('lawCourt.lawCourtType'),
                    field: `lawCourtType`,
                },
                {
                    label: this.$t('lawCourt.law_matter_case_type'),
                    field: `lawMatterCaseType`,
                },
                {
                    label: '',
                    field: 'process',
                    width: '10em',
                    sortable: false
                },
            ],
            rows: [],
            searchTerm: '',
        }
    },
    mounted() {
        this.getLawCourtList()
    },
    methods: {
        async deleted(data) {
            data = {
                id: data.id
            }
            const controller = {
                name: 'LawCourt'
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$DeleteConfirm().then(result => {
                if (result.value) {
                    this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.$DeleteAlert()
                            this.getLawCourtList()
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                            this.getLawCourtList()
                        }
                    })
                }
            })
        },
        async getInfo(id) {
            this.$refs.lawCourtFormModal.showInfo(id)
        },
        getLawCourtList() {
            this.rows = []

            const data = {
                lawCourtTypeId: this.lawCourtTypeSelect,
                lawMatterCaseTypeId: this.lawMatterCaseTypeSelect,
            }

            const controller = {
                name: 'LawCourt'
            }
            
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/getList', payload).then((response) => {
                if (response.data.resultStatus == true) {

                    this.rows = response.data.lawCourtList

                    this.lawCourtTypeOption = response.data.lawCourtTypeList
                    this.lawCourtTypeOption.splice(0, 0, this.$nullSelected())

                    this.lawMatterCaseTypeOption = response.data.lawMatterCaseTypeList
                    this.lawMatterCaseTypeOption.splice(0, 0, this.$nullSelected())
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        },
        exportExcel() {
            const controller = {
                name: 'LawCourt',
                actionName: 'CanExport'
            }
            const data = {
                columnList: this.columns,
                DataList: this.rows
            }
            const payload = {
                data: data,
                controller: controller
            }
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.$downloadFile("LawCourt", response.data.base64, 'xlsx')
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
            })
        }
    },
}
</script>

<style lang="scss">
.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}
</style>
